module.exports = __webpack_public_path__ + "static/media/mainimg-04.888e30eb.png";